
import PasswordResetComplete from "@/components/auth/PasswordResetComplete";

const PasswordReset = () => {
  return <PasswordResetComplete />;
};

export default PasswordReset;
